// errorCode: errorMessage
export default {
  24800: '현재는 게임 점검 중이므로 구매할 수 없습니다.<br>게임 점검 이후 재시도 해주세요.',
  24801: '캐릭터 직업 조건이 맞지 않아 구매할 수 없습니다.',
  24802: '캐릭터 레벨 조건이 맞지 않아 구매할 수 없습니다.',
  24803: '패키지 구매 조건을 충족하지 않았습니다.<br>상세 설명을 확인해주세요.',
  24705: '현재 구매 불가한 상품입니다.',
  24001: '이미 구매하신 상품입니다.<br>게임에서 아이템 지급 받으신 후 다시 구매할 수 있습니다.',
  29040: '현재 접속하신 국가에서는 결제를 지원하지 않습니다.',
  29042: '구매 한도를 초과하였습니다.',
  29045: '상품 구매는 본인 인증 후 이용할 수 있습니다.<br>PC에서 넥슨닷컴>내정보 접속하여 본인인증 후 이용해 주세요.',
  default:
    '죄송합니다.<br>알 수 없는 오류가 발생하여 구매가 불가능합니다.<br>잠시 후 다시 시도해 주세요.'
}
